export default __webpack_public_path__ + "static/media/850.8b1035b5.gif";